<template>
  <div>Yandex</div>
</template>
<script>

export default {
  props: {
  },
  setup (props, { root }) {
    return {
    }
  }
}
</script>
